import SocialSharingContainer from './social_sharing_container';

const SocialSharing = SocialSharingContainer;
export default SocialSharing;
